import {
  ConsentFormTemplate,
  DefaultConsentForms,
  getDefaultConsentForms,
  PopulatedAssessment,
} from '@hb/shared'
import { useMemo } from 'react'

export const useDefaultConsentForms = (
  assessment: PopulatedAssessment | null,
  practiceId: string | null | undefined,
  hbConsentForms: Record<string, ConsentFormTemplate> | null,
  practiceConsentForms: Record<string, ConsentFormTemplate> | null,
): DefaultConsentForms =>
  useMemo(() => {
    if (!assessment || !practiceConsentForms || !hbConsentForms || !practiceId)
      return {
        practice: [],
        hb: [],
        practiceId: practiceId ?? null,
      }
    return getDefaultConsentForms(assessment, practiceId, hbConsentForms, practiceConsentForms)
  }, [assessment, practiceConsentForms, hbConsentForms, practiceId])
